import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { BackToTop } from '@/components/BackToTop';
import { lazy, Suspense, useState, useEffect } from 'react';
import { useGeolocationPrompt } from '@/hooks/useGeolocationPrompt';

const Chatbot = lazy(() => import('@/components/chatbot/Chatbot').then(m => ({ default: m.Chatbot })));

export function Layout() {
  const [showChatbot, setShowChatbot] = useState(false);
  useGeolocationPrompt();

  useEffect(() => {
    // Defer chatbot loading until browser is idle or after 5s max
    if ('requestIdleCallback' in window) {
      const id = (window as any).requestIdleCallback(() => setShowChatbot(true), { timeout: 15000 });
      return () => (window as any).cancelIdleCallback(id);
    } else {
      const timer = setTimeout(() => setShowChatbot(true), 12000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {showChatbot && (
        <Suspense fallback={null}>
          <Chatbot />
        </Suspense>
      )}
      <BackToTop />
    </div>
  );
}
